import React, { createContext, useReducer } from 'react'

// Create initial context based on information in Module Menu.
// This will keep track of a users progress at any given time.
// TODO: Use cookies or something to save progress if user closes browser.

const pageInfo = { allowSkip: true }

const pageStore = createContext(pageInfo)
const { Provider } = pageStore

const PageStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'ready-to-move-on':
        state.readyToMoveOn = action.ready
        return { ...state }
      case 'toggle-skip':
        state.allowSkip = action.toggle
        return { ...state }
      default:
        throw new Error()
    }
  }, pageInfo)

  return <Provider value={{ state, dispatch }}> {children}</Provider>
}

export { pageStore, PageStoreProvider }
